import React from 'react'
import AboutCover from '../AboutCover/AboutCover'
import AboutInfo from '../AboutInfo/AboutInfo'
import ContactMe from '../ContactMe/ContactMe'
import Header from '../Header/Header'

const AboutPage = () => {
  return (
    <div>
      <Header/>  
      <AboutCover/>
      <AboutInfo/>
      <ContactMe/>
    </div>
  )
}

export default AboutPage
